import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["color", "fieldDisabled", "switchValue", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { FormControl, styled, SwitchUnstyled, switchUnstyledClasses } from '@mui/material';
import React from 'react';
var Root = styled('span')(function () {
  return "\n  font-size: 0;\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 20px;\n  margin: 10px;\n  cursor: pointer;\n\n  &.".concat(switchUnstyledClasses.disabled, " {\n    cursor: not-allowed;\n    backgound-color: 'neutrals.primary'\n  }\n\n  & .").concat(switchUnstyledClasses.track, " {\n    background: 'neutrals.primary';\n    border-radius: 10px;\n    display: block;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n  }\n\n  & .").concat(switchUnstyledClasses.thumb, " {\n    display: block;\n    width: 16px;\n    height: 16px;\n    top: 3px;\n    left: 3px;\n    border-radius: 16px;\n    background-color: #fff;\n    position: relative;\n    transition: all 200ms ease;\n  }\n\n  &.").concat(switchUnstyledClasses.focusVisible, " .").concat(switchUnstyledClasses.thumb, " {\n    background-color: 'neutrals.primary';\n    box-shadow: 0 0 1px 8px rgba(0, 0, 0, 0.25);\n  }\n\n  &.").concat(switchUnstyledClasses.checked, " {\n    .").concat(switchUnstyledClasses.thumb, " {\n      left: 22px;\n      top: 3px;\n      background-color: #fff;\n    }\n  }\n\n  & .").concat(switchUnstyledClasses.input, " {\n    cursor: inherit;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    z-index: 1;\n    margin: 0;\n  }\n  ");
});

var TAGSwitchInput = function TAGSwitchInput(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$fieldDisabled = _ref.fieldDisabled,
      fieldDisabled = _ref$fieldDisabled === void 0 ? false : _ref$fieldDisabled,
      switchValue = _ref.switchValue,
      sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded);

  var transformedColor = color.includes('.') ? color : "".concat(color, ".main");
  var colorConditional = {
    color: fieldDisabled ? 'text.disabled' : transformedColor
  };
  var toggleConditional = switchValue === false ? 'neutrals.primary' : transformedColor;
  return React.createElement(FormControl, {
    disabled: fieldDisabled,
    sx: [{
      '& .MuiFormLabel-root': {
        color: colorConditional
      },
      '& .MuiSwitch-root ': {
        '.MuiSwitch-track': {
          bgcolor: fieldDisabled && (switchValue === true || switchValue === false) ? 'neutrals.primary' : toggleConditional
        }
      },
      '.MuiSwitch-thumb': {
        mt: '-1px',
        height: 16,
        width: 16,
        boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.24)'
      }
    }, sx]
  }, React.createElement(SwitchUnstyled, _objectSpread(_objectSpread({}, props), {}, {
    className: fieldDisabled ? 'disabledToggle' : 'notDisabled',
    disabled: fieldDisabled,
    component: Root
  })));
};

export default TAGSwitchInput;